import { TeamReportDataTableRow } from "../../TeamReportDataTable/types";
import { AdvancedStatsSectionProps } from "./types";

const OFFENSE_METRICS = ["USG%", "TS%", "AST%", "TOV%"];
const REBOUNDING_METRICS = ["DRB%", "ORB%"];
const DEFENSE_METRICS = ["STL%", "BLK%", "Rim Contest%", "Rim Contest TS%"];

export function transformAdvancedStats(
  rows: TeamReportDataTableRow[]
): AdvancedStatsSectionProps {
  const dataRow = rows.find((row) => row.name === "Overall") ?? rows[0];
  if (!dataRow) {
    return {
      offenseMetrics: [],
      reboundingMetrics: [],
      defenseMetrics: [],
    };
  }

  return {
    offenseMetrics: OFFENSE_METRICS.map((metric) => ({
      name: metric,
      value: dataRow.cells[metric]?.value ?? NaN,
      percentile: dataRow.cells[metric]?.percentile,
      rank: dataRow.cells[metric]?.rank,
    })),
    reboundingMetrics: REBOUNDING_METRICS.map((metric) => ({
      name: metric,
      value: dataRow.cells[metric]?.value ?? NaN,
      percentile: dataRow.cells[metric]?.percentile,
      rank: dataRow.cells[metric]?.rank,
    })),
    defenseMetrics: DEFENSE_METRICS.map((metric) => ({
      name: metric,
      value: dataRow.cells[metric]?.value ?? NaN,
      percentile: dataRow.cells[metric]?.percentile,
      rank: dataRow.cells[metric]?.rank,
    })),
  };
}
